/* =========================================================================
   PILATIX — Collection page behaviour
   * Mobile filter/sort bottom-sheet
   * Auto-submit form on change (page reload — keeps filter state in URL)
   * Quick-add form submit → cart drawer open (fallback: /cart page)
   ========================================================================= */

(function () {
  'use strict';

  var COLL_SELECTOR = '.pltx2-coll';
  var SIDEBAR_ID    = 'PltxCollSidebar';

  // -------- mobile sheet ------------------------------------------------
  function initSheet(root) {
    if (!root) return;
    var sidebar  = root.querySelector('#' + SIDEBAR_ID);
    var backdrop = root.querySelector('.pltx2-coll__backdrop');
    if (!sidebar) return;

    function open(mode) {
      root.classList.add('is-sheet-open');
      if (mode === 'sort')    root.classList.add('is-sheet-sort');
      if (mode === 'filters') root.classList.add('is-sheet-filters');
      if (backdrop) backdrop.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      root.classList.remove('is-sheet-open', 'is-sheet-sort', 'is-sheet-filters');
      if (backdrop) backdrop.hidden = true;
      document.body.style.overflow = '';
    }

    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-pltx-sheet-open]');
      if (openBtn) {
        e.preventDefault();
        open(openBtn.getAttribute('data-pltx-sheet-open'));
        return;
      }
      var closeBtn = e.target.closest('[data-pltx-sheet-close]');
      if (closeBtn) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-sheet-open')) {
        close();
      }
    });
  }

  // -------- auto-submit filter/sort form --------------------------------
  function initFilterForm(root) {
    var form = root.querySelector('#PltxFilterForm');
    if (!form) return;

    var debounceTimer = null;
    function submitForm() {
      // Remove empty values so URL stays clean
      var params = new URLSearchParams(new FormData(form));
      var clean  = new URLSearchParams();
      params.forEach(function (v, k) {
        if (v !== '' && v != null) clean.append(k, v);
      });
      var q = clean.toString();
      window.location.search = q ? '?' + q : '';
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.type === 'checkbox' || t.type === 'radio') {
        submitForm();
      } else if (t.type === 'number') {
        // debounce numeric input
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(submitForm, 600);
      }
    });
  }

  // -------- quick-add submit → open cart drawer -------------------------
  function initQuickAdd(root) {
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pltx-quickadd]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var originalLabel = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = pltxT('pltx2.js.k047', 'מוסיף…');
      }

      var formData = new FormData(form);
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript, application/json' },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) throw new Error('fail');
          return r.json();
        })
        .then(function () {
          // Try to open the theme's cart drawer
          if (btn) btn.textContent = pltxT('pltx2.js.k062', 'נוסף ✓');
          var drawerOpen = document.querySelector('cart-drawer, [data-cart-drawer]');
          if (drawerOpen && typeof drawerOpen.open === 'function') {
            drawerOpen.open();
          } else {
            // Fire a generic event in case the theme listens
            document.dispatchEvent(new CustomEvent('pltx:cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            // Fetch and refresh cart count header (best-effort)
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              })
              .catch(function () {});
          }

          // Reset button label after 1.4s
          if (btn) {
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = originalLabel || pltxT('pltx2.js.k023', 'הוסף לסל');
            }, 1400);
          }
        })
        .catch(function () {
          // Fallback — submit the form normally
          if (btn) {
            btn.disabled = false;
            btn.textContent = originalLabel || pltxT('pltx2.js.k023', 'הוסף לסל');
          }
          form.submit();
        });
    });
  }

  // -------- price input formatting: thousands separator + auto ₪ ---------
  function initPriceInputs(root) {
    if (!root) return;
    var inputs = root.querySelectorAll('[data-pltx-price-fmt]');
    if (!inputs.length) return;

    function formatNumber(n) {
      if (n === '' || n == null || isNaN(n)) return '';
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function stripFormat(s) {
      return String(s).replace(/[^0-9]/g, '');
    }

    inputs.forEach(function (el) {
      // Format initial value
      if (el.value) el.value = formatNumber(stripFormat(el.value));

      el.addEventListener('input', function () {
        var digits = stripFormat(el.value);
        var max = parseInt(el.getAttribute('data-max'), 10);
        if (!isNaN(max) && digits && parseInt(digits, 10) > max) digits = String(max);
        var formatted = formatNumber(digits);
        var caret = el.selectionStart;
        var before = el.value;
        el.value = formatted;
        // Try to preserve caret position reasonably
        var diff = formatted.length - before.length;
        try { el.setSelectionRange(caret + diff, caret + diff); } catch (e) {}
      });

      // Strip formatting before the form submits so Shopify gets raw numbers
      var form = el.closest('form');
      if (form && !form._pltxPriceHooked) {
        form._pltxPriceHooked = true;
        form.addEventListener('submit', function () {
          form.querySelectorAll('[data-pltx-price-fmt]').forEach(function (i) {
            i.value = stripFormat(i.value);
          });
        });
      }
    });
  }

  // -------- scroll-triggered UI (compact header) --------------------------
  // Toggles `is-scrolled` on the collection section once the big collection
  // title scrolls out of the viewport. Mobile CSS reveals the compact header.
  //
  // Also measures the theme site-header's current height and exports it as
  // --pltx-theme-header-h so the compact header sits FLUSH under it (height
  // changes on mobile scroll-shrink, announcement bar hide, etc.)
  function initScrollUX(root) {
    var themeHeader = document.querySelector('.shopify-section-group-header-group') ||
                      document.querySelector('sticky-header') ||
                      document.querySelector('header.header');

    function syncThemeHeight() {
      if (!themeHeader) return;
      var rect = themeHeader.getBoundingClientRect();
      // Bottom edge (viewport-relative) — the exact Y where the compact header should start
      var bottom = Math.max(0, Math.round(rect.bottom));
      document.documentElement.style.setProperty('--pltx-theme-header-h', bottom + 'px');
    }

    syncThemeHeight();
    window.addEventListener('resize', syncThemeHeight, { passive: true });
    window.addEventListener('scroll', syncThemeHeight, { passive: true });
    if (themeHeader && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(syncThemeHeight);
      ro.observe(themeHeader);
    }

    var sentinel = document.querySelector('.pltx2-coll-banner__title, .pltx2-coll-banner__text');
    if (!sentinel || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.remove('is-scrolled');
        } else {
          if (entry.boundingClientRect.top < 0) {
            root.classList.add('is-scrolled');
          }
        }
      });
    }, { threshold: 0, rootMargin: '-1px 0px 0px 0px' });

    io.observe(sentinel);

    // Hide the compact header when the footer enters the viewport — prevents
    // the ugly overlap with footer content as the user reaches the page end.
    var footer = document.querySelector('footer, .footer, [class*="footer"][class*="shopify-section"]');
    if (footer) {
      var footerIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-near-footer');
          } else {
            root.classList.remove('is-near-footer');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
      footerIo.observe(footer);
    }
  }

  // -------- init --------------------------------------------------------
  function init() {
    var roots = document.querySelectorAll(COLL_SELECTOR);
    roots.forEach(function (root) {
      initSheet(root);
      initFilterForm(root);
      initQuickAdd(root);
      initPriceInputs(root);
      initScrollUX(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
